/* eslint-disable @typescript-eslint/naming-convention */
import React, { useContext } from 'react';
import { PageStateContext } from '../../services';
import { AnyProps } from '../types';
import { InjectBlackTriangle } from './black-triangle';

export const RocheStyledText = ({ blok, slot, getComponent }: AnyProps): JSX.Element => {
  const pageContext = useContext(PageStateContext);

  return React.createElement('roche-styled-text', {
    'styled-text': InjectBlackTriangle(blok.styled_text, pageContext, getComponent),
    'styled-text_type': blok.styled_text_type,
    // eslint-disable-next-line no-underscore-dangle
    uid: blok._uid,
    ...(slot ? { slot } : {}),
  });
};
